var path = '/shared/javascripts/templates/product_image/product_image.html';
var html = "<img ng-src=\"{{::imgSrc()}}\"\n     alt=\"{{::productLine.name}}\" ng-style=\"::sizeStyle\"></img>\n";
window.angular.module('tiz').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;